import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { toast } from 'sonner';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const MarketStartPriceEditor = ({ token, current, onSaved }) => {
  const [value, setValue] = useState('');
  useEffect(() => { if (current != null) setValue(String(current)); }, [current]);

  const save = async () => {
    try {
      await axios.put(`${API}/pas-admin/market/start-price`, { usdc_per_beth: parseFloat(value) }, { headers: { Authorization: `Bearer ${token}` } });
      toast.success(`Pool will start at $${Number(value).toLocaleString()} per BETH`);
      onSaved();
    } catch (e) { toast.error(e.response?.data?.detail?.[0]?.msg || e.response?.data?.detail || 'Could not save price'); }
  };

  return (
    <div className="flex items-end gap-2" data-testid="market-start-price-editor">
      <label className="text-sm text-slate-300 space-y-1 flex-1">Pool starting price (USDC per 1 BETH)
        <input type="number" min="0" value={value} onChange={(e) => setValue(e.target.value)} data-testid="market-start-price-input"
          className="w-full bg-slate-800 border border-slate-600 rounded px-3 py-2 text-white font-mono" />
      </label>
      <button onClick={save} disabled={!(value > 0) || Number(value) === Number(current)} data-testid="market-start-price-save-btn"
        className="px-4 py-2 text-sm rounded bg-slate-700 hover:bg-slate-600 disabled:text-slate-500 disabled:cursor-not-allowed text-white">Save</button>
    </div>
  );
};

export default MarketStartPriceEditor;
